import classNames from 'classnames'

import ImageDescriptionBullets from '../ImageDescriptionBullets/ImageDescriptionBullets'
import RupayStack from './RupayStack'
import RupaySuccess from './RupaySuccess'
import BenefitCard from '../BenefitCard/BenefitCard'
import styles from './RupayLayout.module.scss'
import { useNavigate } from 'react-router-dom'

function RupayInfraLayout({ selectedCard }) {
  const navigate = useNavigate()
  const handleNavigation = (buttonDetails) => {
    if (buttonDetails?.isExternal) {
      return window.open(buttonDetails?.path, '_blank', 'noopener,noreferrer')
    }
    navigate(buttonDetails?.path)
  }
  return (
    <>
      <div
        className={classNames('page-container', styles.benefitsCardContainer)}
      >
        <h1>{selectedCard?.benefitsheader}</h1>
        {selectedCard?.benefitscards &&
          selectedCard?.benefitscards.length > 0 && (
            <div className={classNames(styles.benefitsCardsContainer)}>
              {selectedCard?.benefitscards.map((card) => {
                return (
                  <BenefitCard
                    key={card?.id}
                    title={card.title}
                    description={card.description}
                    image={card.cardimage}
                    markdownClass={styles.markdownClass}
                  />
                )
              })}
            </div>
          )}
      </div>
      <ImageDescriptionBullets
        bulletstitle={selectedCard.bulletstitle}
        image={selectedCard.image}
        button={selectedCard.button}
        bulletssubsection={selectedCard.bulletssubsection}
        bulletsdescription={selectedCard.bulletsdescription}
        className={classNames('page-container', styles.imageDescription)}
        handleNavigation={handleNavigation}
      />
      {selectedCard.bannertitle && (
        <RupayStack
          header={selectedCard.bannertitle}
          stack={selectedCard.bannerdata}
        />
      )}
      {selectedCard.feature_title && (
        <RupaySuccess
          title={selectedCard.feature_title}
          description={selectedCard.feature_description}
          cardHeader={selectedCard.feature_sub_title}
          cards={selectedCard.keyfeatures}
        />
      )}
    </>
  )
}

export default RupayInfraLayout
